"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = require("react-native-svg");
const LoadingIcon = ({ width, height, color }) => {
    return (react_1.default.createElement(react_native_svg_1.Svg, { width: width, height: height },
        react_1.default.createElement(react_native_svg_1.Defs, null,
            react_1.default.createElement(react_native_svg_1.LinearGradient, { x1: "100%", y1: "68.182%", x2: "12.578%", y2: "12.882%", id: "a" },
                react_1.default.createElement(react_native_svg_1.Stop, { stopColor: color || '#2EFF2B', offset: "0%" }),
                react_1.default.createElement(react_native_svg_1.Stop, { stopColor: color || '#0F62DD', offset: "52.383%" }),
                react_1.default.createElement(react_native_svg_1.Stop, { stopColor: color || '#000270', offset: "100%" }))),
        react_1.default.createElement(react_native_svg_1.Path, { d: "M187 607c-9.941 0-18 8.059-18 18s8.059 18 18 18 18-8.059 18-18", transform: "translate(-166 -604)", stroke: "url(#a)", strokeWidth: "4.2", fill: "none", strokeLinecap: "round" })));
};
LoadingIcon.defaultProps = {
    width: '42',
    height: '42',
};
exports.default = react_1.default.memo(LoadingIcon);
